import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const TENANT_API = `${LOCAL_URL}/tenant/creatTenant`
export const LIST_TENANT_API = `${LOCAL_URL}/tenant/listTenant`
export const GET_SUB_DIV_API = `${LOCAL_URL}/property/listPropertySubUnits`

export const GET_TENANT_DOC_TYPES = `${LOCAL_URL}/tenant/propertyTenantDocumentType`
export const GET_TENANT_DOCUMENTS = `${LOCAL_URL}/tenant/propertyTenantDocument`
export const UPLOAD_TENANT_DOCUMENTS = `${LOCAL_URL}/propertyTenantDocUpload`
export const GET_VIEW_TENANT = `${LOCAL_URL}/tenant/viewTenant`
export const BLOCK_TENANT = `${LOCAL_URL}/tenant/blockTenant`
export const UNBLOCK_TENANT = `${LOCAL_URL}/tenant/unblockTenant`
export const EDIT_TENANT = `${LOCAL_URL}/tenant/editTenant`
export const GET_TENANTS = `${LOCAL_URL}/tenant/new-tenant`
const headers = {
  Authorization: API_TOKEN,
}

// function to create tenant
export async function create_tenant(
  tenant_name,
  tenant_email_id,
  tenant_contact_number,
  property_uuid,
  property_rent_rate,
  property_rent_due_date,
  security_deposit,
  property_sub_unit_uuid,
  rental_agreement_date,
  tenancy_commencement_date,
  tenancy_expiration_date,
  business_name = '',
  business_email_id = '',
  business_contact_number = '',
  utilities_deposit = 0,
  other_deposits = 0,
  tenancy_term = 0,
  property_rent_start_date = '',
  property_rent_end_date = ''
) {
  let data = {
    tenant_name: tenant_name,
    tenant_email_id: tenant_email_id,
    tenant_contact_number: tenant_contact_number,
    property_uuid: property_uuid,
    property_rent_rate: property_rent_rate,
    property_rent_due_date: property_rent_due_date,
    security_deposit: security_deposit,
    property_sub_unit_uuid: property_sub_unit_uuid,
    tenancy_commencement_date: tenancy_commencement_date,
    tenancy_expiration_date: tenancy_expiration_date,
    rental_agreement_date: rental_agreement_date,
    business_name: business_name,
    business_email_id: business_email_id,
    business_contact_number: business_contact_number,
    utilities_deposit: utilities_deposit,
    other_deposits: other_deposits,
    tenancy_term: tenancy_term,
    property_rent_start_date: property_rent_start_date,
    property_rent_end_date: property_rent_end_date,
  }

  return await axios.post(TENANT_API, data)
}

// function to create tenant
export async function create_com_tenant(
  tenant_name,
  tenant_email_id,
  tenant_contact_number,
  property_rent_date,
  property_rent_start_date,
  property_rent_end_date,
  property_rent_rate,
  property_uuid
) {
  return await axios.post(TENANT_API, {
    tenant_name,
    tenant_email_id,
    tenant_contact_number,
    property_rent_date,
    property_rent_start_date,
    property_rent_end_date,
    property_rent_rate,
    property_uuid,
  })
}

//function to list all tenant
export async function list_tenant(property_uuid, offset, limit, search) {
  return await axios.post(LIST_TENANT_API, {
    property_uuid,
    offset,
    limit,
    search,
  })
}

// function to get Sub divions
export async function get_Subdivions(property_uuid) {
  return await axios.post(
    GET_SUB_DIV_API,
    {property_uuid},
    {
      headers,
    }
  )
}

// function to get tenant document types
export async function Get_Tenant_Doc_Types() {
  return await axios.get(GET_TENANT_DOC_TYPES)
}

// function to get tenant documents
export async function Get_Tenant_Documents(tenant_account_uuid) {
  return await axios.post(GET_TENANT_DOCUMENTS, {
    tenant_account_uuid,
  })
}

// function to upload tenant documents
export async function Upload_Tenant_Documents(
  property_tenant_document_type_uuid,
  document_label,
  property_uuid,
  tenant_account_uuid,
  file
) {
  return await axios.post(UPLOAD_TENANT_DOCUMENTS, {
    property_tenant_document_type_uuid,
    document_label,
    property_uuid,
    tenant_account_uuid,
    file,
  })
}

//function to view tenant details
export async function Get_View_Tenant(tenant_account_uuid) {
  return await axios.post(GET_VIEW_TENANT, {
    tenant_account_uuid,
  })
}

// function to block tenant
export async function Block_Tenant(tenant_account_uuid) {
  return await axios.post(BLOCK_TENANT, {tenant_account_uuid})
}

// function to block tenant
export async function Unblock_Tenant(tenant_account_uuid) {
  return await axios.post(UNBLOCK_TENANT, {tenant_account_uuid})
}

// function to edit tenant
export async function Edit_Tenant(
  tenant_account_uuid,
  property_sub_unit_uuid,
  property_rent_rate,
  business_name,
  business_email_id,
  business_contact_number,
  property_rent_due_date,
  security_deposit,
  utilities_deposit,
  other_deposits,
  rental_agreement_date,
  tenancy_term,
  tenancy_commencement_date,
  tenancy_expiration_date,
  property_rent_start_date,
  property_rent_end_date
) {
  return await axios.post(EDIT_TENANT, {
    tenant_account_uuid,
    property_sub_unit_uuid,
    property_rent_rate,
    business_name,
    business_email_id,
    business_contact_number,
    property_rent_due_date,
    security_deposit,
    utilities_deposit,
    other_deposits,
    rental_agreement_date,
    tenancy_term,
    tenancy_commencement_date,
    tenancy_expiration_date,
    property_rent_start_date,
    property_rent_end_date,
  })
}

export async function Get_Tenants(property_id) {
  return await axios.post(GET_TENANTS, {
    property_id,
  })
}
